import React from "react";

import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green, grey, orange } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    border: "1px dashed",
    borderRadius: theme.spacing(1),
    borderColor: grey[400],
    padding: theme.spacing(2),
  },
  locationItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  locationAvatar: {
    color: theme.palette.text.primary,
    margin: theme.spacing(1),
  },
  locationCompletedAvatar: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
    borderColor: green[200],
    margin: theme.spacing(1),
  },
  locationInProgressAvatar: {
    color: theme.palette.getContrastText(orange[200]),
    backgroundColor: orange[200],
    borderColor: orange[200],
    margin: theme.spacing(1),
  },
}));

const getColor = (currentAudit, locations, idx, classes) => {
  const location = locations[idx];
  if (
    currentAudit.processedLocations[location.id] &&
    currentAudit.processedLocations[location.id].completed >=
      currentAudit.processedLocations[location.id].total
  ) {
    return classes.locationCompletedAvatar;
  } else if (
    currentAudit.processedLocations[location.id] &&
    currentAudit.processedLocations[location.id].completed > 0
  ) {
    return classes.locationInProgressAvatar;
  } else return classes.locationAvatar;
};

const LocationsMap = ({ currentAudit, locations }) => {
  const classes = useStyles();
  return currentAudit?.id ? (
    <div className={classes.root}>
      {locations.length > 0 &&
        locations.map((itm, idx) => (
          <div key={itm.id} className={classes.locationItem}>
            <Chip
              variant="outlined"
              className={getColor(currentAudit, locations, idx, classes)}
              label={window.appUser?.reloadYard.locationMap[itm].name}
            />
          </div>
        ))}
    </div>
  ) : (
    <></>
  );
};

export default LocationsMap;
